import React from 'react';
import { db } from '../../config/firebase';
import { doc, collection, setDoc, getDocs, query, where } from 'firebase/firestore';
import { Button, Tooltip, Chip, Stack } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';

const PlayGenId = ({ username, recentText, accuracyScore }) => {
  const generateTokenId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length: 6 }, () => 
      characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  };

  const handleGenerateId = async () => {
    if (!username || !recentText) return;

    let uniqueTokenId = '';
    try {
      const userDocRef = doc(db, 'users', username);
      const tokensCollectionRef = collection(userDocRef, 'tokens');
      
      // Generate unique ID with retry logic
      let attempts = 0;
      while (attempts < 5) {
        uniqueTokenId = generateTokenId();
        const tokenQuery = query(tokensCollectionRef, where('tokenId', '==', uniqueTokenId));
        const querySnapshot = await getDocs(tokenQuery);
        if (querySnapshot.empty) break;
        attempts++;
      }

      if (attempts === 5) throw new Error('Could not generate unique ID');

      await setDoc(doc(tokensCollectionRef, uniqueTokenId), {
        tokenId: uniqueTokenId,
        text: recentText,
        plagiarism: accuracyScore,
        createdAt: new Date(),
        plagiarismCheck: true // Flag for plagiarism-specific tokens
      });

      const link = `https://synthetica.in/token/${username}/${uniqueTokenId}`;
      await navigator.clipboard.writeText(link);
      
    } catch (error) {
      console.error("Error generating token:", error);
      alert('Error generating shareable link');
    }
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2 }}>
      <Tooltip title="Generate shareable report link">
        <Button
          variant="outlined"
          startIcon={<LinkIcon />}
          onClick={handleGenerateId}
          disabled={!username || !recentText}
          sx={{
            background: 'linear-gradient(45deg, #6366f1 0%, #3b82f6 100%)',
            color: 'white',
            border: 'none',
            '&:hover': {
              background: 'linear-gradient(45deg, #4f46e5 0%, #2563eb 100%)',
              boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)'
            },
            '&.Mui-disabled': {
              background: '#2d3748',
              color: '#718096'
            }
          }}
        >
          Share Report
        </Button>
      </Tooltip>
      
      {accuracyScore && (
        <Chip
          label={`Originality: ${100 - accuracyScore}%`}
          variant="outlined"
          color={accuracyScore >= 50 ? 'error' : 'success'}
          sx={{ fontWeight: 700, borderWidth: 2 }}
        />
      )}
    </Stack>
  );
};

export default PlayGenId;